export const getStoreName = () => {
	const dineInSubDomainPrefix = process.env.REACT_APP_DINEIN_BASE_SUBDOMAIN
	const storeName = window.location.hostname.substring(0, window.location.hostname.indexOf(`.${dineInSubDomainPrefix}`))
	return storeName;
}
export default {};